import { ImagePaths } from '../../lib/imageUrls.js';

export const securityFundamentals = {

    id: 1,
    slug: 'security-fundamentals',
    ogImage: '/og/courses/security-fundamentals.jpg',
    courseCode: 'SEC-FND-001',
    title: 'Security Fundamentals',
    subtitle: 'Build a strong foundation in information security',
    valueProposition: 'Master enterprise-grade security principles and gain practical skills to protect Australian organisations from evolving cyber threats.',
    duration: '40 hours',
    students: 'New',
    level: 'Foundational',
    image: ImagePaths.COURSE_1,
    shortDescription: 'SEC-FND-001 — Foundational information security covering CIA triad, threats, controls, and ISO 27001 alignment for Australian IT professionals.',
    price: {
      aud: 499,
      currency: 'AUD',
      earlyBird: 399
    },
    stripeConfig: {
    priceId: 'price_1SdKSZKu1nyc322Uta8ky422',
    productId: 'prod_TaVTpq68Ykdisd'
  },
    
    snapshot: {
      whoItsFor: [
        'IT professionals transitioning to security roles',
        'System administrators expanding their skillset',
        'Business managers responsible for security oversight'
      ],
      accreditation: 'Aligned to ISO 27001 & NIST frameworks'
    },
    
    logistics: {
      classSize: 'Maximum 15 participants for personalised attention',
      requirements: [
        'Laptop with Windows 10+ or macOS',
        'Reliable internet connection (minimum 10 Mbps)',
        'Basic familiarity with IT systems and networks'
      ]
    },
    
    overview: 'This comprehensive course provides a solid foundation in information security principles, practices, and technologies. You\'ll learn essential concepts that form the backbone of modern cybersecurity, preparing you for more advanced security roles in Australian enterprises.',
    
    outcomes: [
      'Apply core information security principles and the CIA triad to protect organisational assets',
      'Identify and assess common security threats and vulnerabilities in Australian enterprise environments',
      'Implement effective security controls and industry best practices',
      'Evaluate and apply security frameworks including ISO 27001 and Essential Eight',
      'Conduct risk assessments and basic security audits',
      'Communicate security concepts clearly to technical and non-technical stakeholders',
      'Develop security policies aligned to Australian Privacy Principles',
      'Respond effectively to security incidents using established procedures'
    ],
    
    audience: [
      'IT professionals transitioning to security roles',
      'Entry-level security analysts and administrators',
      'Business professionals seeking security awareness',
      'Developers interested in secure coding practices',
      'Anyone starting a career in cybersecurity'
    ],
    
    prerequisites: [
      'Basic understanding of computer systems and networks',
      'Familiarity with operating systems (Windows/Linux)',
      'No prior security experience required'
    ],
    
    modules: [
      {
        title: 'Introduction to Information Security',
        duration: '6 hours',
        topics: [
          'Security fundamentals and the CIA triad',
          'Security governance and risk management',
          'Security policies and procedures',
          'Legal and regulatory requirements'
        ]
      },
      {
        title: 'Threat Landscape',
        duration: '8 hours',
        topics: [
          'Common attack vectors and techniques',
          'Malware types and propagation',
          'Social engineering and phishing',
          'Advanced persistent threats (APTs)'
        ]
      },
      {
        title: 'Security Controls',
        duration: '10 hours',
        topics: [
          'Access control models and authentication',
          'Encryption and cryptography basics',
          'Network security controls',
          'Endpoint protection strategies'
        ]
      },
      {
        title: 'Security Operations',
        duration: '8 hours',
        topics: [
          'Security monitoring and logging',
          'Incident response fundamentals',
          'Vulnerability management',
          'Security awareness training'
        ]
      },
      {
        title: 'Compliance and Frameworks',
        duration: '8 hours',
        topics: [
          'ISO 27001 and security standards',
          'Privacy regulations (GDPR, CCPA)',
          'Industry-specific compliance requirements',
          'Security auditing and assessment'
        ]
      }
    ],
    
    format: {
      type: 'Self-paced online with live sessions',
      includes: [
        '40 hours of video content',
        'Hands-on lab exercises',
        'Weekly live Q&A sessions',
        'Course materials and resources',
        'Certificate of completion',
        '6 months access to course materials'
      ]
    },
    
    nextIntake: {
      date: 'Register your interest — we will confirm the next cohort',
      details: 'Start anytime - access materials immediately upon enrolment'
    },
    
    faqs: [
      {
        question: 'What are your rescheduling and refund policies?',
        answer: 'You may reschedule to a future intake up to 7 days before the course start date at no charge. Full refunds are available up to 14 days before commencement. Within 14 days, a 50% administration fee applies. Contact us to discuss special circumstances.'
      },
      {
        question: 'Will I receive a recognised certification?',
        answer: 'Upon successful completion, you\'ll receive a Certificate of Completion from Educ4te. This demonstrates your competency in security fundamentals and can be added to your LinkedIn profile and CV. The course content aligns with industry frameworks including ISO 27001.'
      },
      {
        question: 'What payment methods do you accept?',
        answer: 'We accept all major credit cards (Visa, Mastercard, American Express) processed securely through Stripe. For group bookings or enterprise arrangements, we can accommodate purchase orders and invoicing. All prices are in Australian dollars (AUD) and include GST.'
      },
      {
        question: 'Do you offer private in-house delivery for my organisation?',
        answer: 'Yes, we provide customised in-house training for organisations across Australia. We can tailor course content to your specific environment, security tools, and compliance requirements. Contact us to discuss your needs and receive a quote.'
      },
      {
        question: 'Is the course accessible for participants with disabilities?',
        answer: 'We\'re committed to making our training accessible to all participants. Please contact us before enrolling to discuss any specific accessibility requirements, including materials in alternative formats, so we can make arrangements before your session.'
      },
      {
        question: 'How much time should I allocate each week?',
        answer: 'We recommend setting aside 6-8 hours per week for self-paced modules and live sessions. Most participants complete the 40-hour course within 6-8 weeks while balancing work commitments.'
      },
      {
        question: 'Do I need any prior security experience?',
        answer: 'No prior security experience is required. This course is designed for IT professionals with basic understanding of computer systems and networks who are transitioning into security roles.'
      }
    ]
};
